import type {NfServiceWorkerCommunication} from "@/services/NfServiceWorkerCommunication";
import {NfMessageType} from "@/serviceWorker/workerComponents/NfMessage";
import {AvailabilitySearchStarted} from "@/serviceWorker/workerComponents/MessageTypes/AvailabilitySearchStarted";
import type {Ref} from "@vue/reactivity";
import {ref} from "vue";
import {AvailabilityData} from "@/serviceWorker/workerComponents/MessageTypes/AvailabilityData";

export class NfSearchService {
    private isSearchInProgress: Ref<boolean> = ref(false);
    private searchRequestsInProgress: {[request_id:number]: number} = {};

    constructor(
        private communication: NfServiceWorkerCommunication
    ) {
        this.communication.communicationReadyPromise.then(this.onCommunicationReady.bind(this));
    }

    private onCommunicationReady() {
        this.communication.getMessageObservable(NfMessageType.AvailabilitySearchStarted).subscribe(
            (message) => {
                if (message instanceof AvailabilitySearchStarted) {
                    this.onAvailabilitySearchStarted(message);
                }
            }
        )

        this.communication.getMessageObservable(NfMessageType.AvailabilityData).subscribe(
            (message) => {
                if (message instanceof AvailabilityData) {
                    this.onAvailabilityReceived(message);
                }
            }
        )
    }

    private onAvailabilitySearchStarted(message: AvailabilitySearchStarted) {
        this.isSearchInProgress.value = true;
        this.searchRequestsInProgress[message.getAvailabilityRequestId] = Date.now();
    }

    private onAvailabilityReceived(message: AvailabilityData) {
        delete this.searchRequestsInProgress[message.availabilityRequest.requestId];

        this.removeExpiredSearchRequests();

        //Search is still in progress if there are any more search requests processed
        this.isSearchInProgress.value = Object.keys(this.searchRequestsInProgress).length > 0;
    }

    private removeExpiredSearchRequests() {
        for (const requestId in this.searchRequestsInProgress) {
            const requestTime = this.searchRequestsInProgress[requestId];
            //Expire waiting for requests after 20s
            if (Date.now() - requestTime > 20000) {
                delete this.searchRequestsInProgress[requestId];
            }
        }
    }

    public getSearchInProgress(): Ref<boolean> {
        return this.isSearchInProgress;
    }
}